// Office 服務 · SYSTEM_ADMIN 集中管理 API（Task-33 3.2e）
import axiosInstance from '../api/axios';

const BASE = '/api/system';

export type OfficeTenantStatus = 'ok' | 'off' | 'error';

export interface OfficeTenantRow {
  org_id: number;
  org_code: string;
  org_name: string;
  office_enabled: boolean;
  overall_status: OfficeTenantStatus;
}

export interface OfficeTenantOverview {
  collabora_url: string | null;
  collabora_reachable: boolean;
  collabora_latency_ms: number | null;
  wopi_secret_set: boolean;
  tenants: OfficeTenantRow[];
}

// 單租戶 recheck 回完整 5 checks（與 tenant 端 /office-health 同格式 + org_id）
export interface OfficeHealthRecheck {
  org_id: number;
  office_enabled: boolean;
  overall_status: 'ok' | 'warn' | 'error' | 'off';
  checks: {
    name: string;
    status: 'ok' | 'warn' | 'error' | 'off';
    value?: string | boolean | null;
    latency_ms?: number | null;
    hint?: string | null;
  }[];
}

export const getOfficeTenantOverview = async (): Promise<OfficeTenantOverview> =>
  (await axiosInstance.get<OfficeTenantOverview>(`${BASE}/office-tenant-overview`)).data;

export const setTenantOfficeEnabled = async (orgId: number, enabled: boolean) =>
  (await axiosInstance.put(`${BASE}/tenants/${orgId}/office-enabled`, { enabled })).data;

export const recheckTenantOfficeHealth = async (orgId: number): Promise<OfficeHealthRecheck> =>
  (await axiosInstance.post<OfficeHealthRecheck>(`${BASE}/tenants/${orgId}/office-health-recheck`)).data;
